import { StepPosition, Steps, StepState } from '@sunwebgroup/uds-ui/multi-step-process-indicator'
import * as React from 'react'
import { useIntl } from '@/intl'
import { buildUrlWithCurrentParams } from '@/scopes/checkout/domain/helpers/BuildUrlWithCurrentParams'
import { useBookingDraftQuery, useGetStepsTabs } from '@/scopes/checkout/domain/hooks'
import { hasAnyExternalFlight } from '@/scopes/checkout/domain/policies/transports'
import { useOptimizelyFlagContext } from '@/scopes/common/infrastructure/ab-testing/optimizely/useOptimizely'

export function CheckoutProgressForMandatoryPaymentPage() {
  const { isLoading, activeStep, items } = useGetStepsTabs()

  if (isLoading)
    return ''

  return <CheckoutProgressItems items={items} activeStep={activeStep} />
}

export function CheckoutProgress({ hideExtraStep = false }: { hideExtraStep?: boolean }) {
  let { isLoading, activeStep, items } = useGetStepsTabs()
  const { data } = useBookingDraftQuery()
  const { showMandatoryPaymentPage } = useOptimizelyFlagContext()
  const intl = useIntl()
  //  TODO: remove After AB Test */
  if (!hideExtraStep && items && showMandatoryPaymentPage && hasAnyExternalFlight(data?.transportInfo)) {
    items = [
      ...items,
      {
        text: intl.formatMessage({
          id: 'checkout_steps_step_mandatory_payment_title_progress_tab',
          defaultMessage: 'Payment',
        }),
        disabled: false,
        completed: false,
        url: '',
      },
    ]
  }

  if (isLoading)
    return ''

  return (
    <CheckoutProgressItems items={items} activeStep={activeStep} />
  )
}

function CheckoutProgressItems({ items, activeStep }: { items: Array<{ text: string, disabled: boolean, completed: boolean, url?: string }>, activeStep: string }) {
  if (!items || items.length === 0)
    return null

  return (
    <div data-qa="checkout-progress">
      <Steps.Wrapper>
        {items.map((step, index) => {
          const stepUrl = step.url ?? ''

          return (
            <Steps.Indicator
              key={index}
              value={index + 1}
              state={
                step.completed ? StepState.Complete : step.text === activeStep ? StepState.Current : StepState.Neutral
              }
              link={stepUrl ? { href: `${buildUrlWithCurrentParams(stepUrl)}` } : undefined}
              title={step.text}
              position={
                index === 0 ? StepPosition.First : index === items.length - 1 ? StepPosition.Last : StepPosition.Between
              }
              data-qa="step"
              data-qa-active={activeStep === step.text}
            />
          )
        })}
      </Steps.Wrapper>
    </div>
  )
}
